module.exports = __webpack_public_path__ + "static/media/Alana.9d7e51f2.png";